export const DEFAULT_ZOOM_LEVEL = 1.75